import mapStyle from '../../components/Map/mapStyle.json';

const contactsSlider = new Swiper(".js-contacts-slider", {
    loop: false,
    spaceBetween: 16,
    slidesPerView: "auto",
    navigation: {
        nextEl: ".js-contacts-slider-btn-next",
        prevEl: ".js-contacts-slider-btn-prev",
    },
    breakpoints: {
        768: {
            spaceBetween: 24,
            slidesPerView: "auto",
        },
    },
});

// Инициализация большой карты
async function initMap(rootDom) {
    if (!rootDom) return;

    let lat = $(rootDom).closest(".js-contacts-slider__slide-map-wrap").attr("data-lat");
    let long = $(rootDom).closest(".js-contacts-slider__slide-map-wrap").attr("data-long");

    const swiperDom = $(rootDom).closest(".js-contacts-slider").get(0);
    const swiper = contactsSlider.find((x) => x.el === swiperDom);

    const LOCATION = {
        center: [long, lat],
        zoom: 15
    };
    const ZOOM_RANGE = {
        min: 3,
        max: 19
    };

    await ymaps3.ready;

    ymaps3.import.registerCdn(
        'https://cdn.jsdelivr.net/npm/{package}',
        [
            '@yandex/ymaps3-default-ui-theme@latest'
        ]
    );
    const {
        YMap,
        YMapDefaultSchemeLayer,
        YMapDefaultFeaturesLayer,
        YMapMarker,
        YMapControl,
        YMapControls,
        YMapComplexEntity,
    } = ymaps3;

    const {
        YMapZoomControl
    } = await ymaps3.import('@yandex/ymaps3-default-ui-theme');


    // Иницилиазируем карту
    const map = new YMap(
        rootDom,
        {
            location: LOCATION,
            zoomRange: ZOOM_RANGE,
        }
    );

    map.addChild(new YMapDefaultSchemeLayer({
        // Стилизация карты
        customization: mapStyle
    }));
    map.addChild(new YMapDefaultFeaturesLayer());

    map.addChild(
        new YMapControls({position: 'right'})
            .addChild(new YMapZoomControl({}))
    );

    // Рендер пина
    const createMarker = () => {
        const element = document.createElement('div');
        element.className = 'pin';

        element.addEventListener('click', () => {
            map.update({
                location: {
                    center: [long, lat],
                    duration: 300
                }
            });

            showBalloon();
        });

        return new YMapMarker(
            {
                coordinates: [long, lat]
            },
            element
        );
    };

    map.addChild(createMarker());

    // Карточка пина
    let currentBalloon = null;

    const showBalloon = () => {
        if (currentBalloon) {
            map.removeChild(currentBalloon);
        }

        const balloon = document.createElement('div');

        balloon.className = 'balloon';

        balloon.innerHTML = `
            <div class="balloon-title">
                ${$(rootDom).data('baloon-header')}
            </div>
            <div class="balloon-text">
                ${$(rootDom).data('baloon-body')}
            </div>
            <div class="balloon-footer">
                ${$(rootDom).data('baloon-footer')}
            </div>
            <button class="balloon-close">✕</button>
        `;

        balloon.querySelector('.balloon-close').addEventListener('click', closeBalloon);

        currentBalloon = new YMapMarker(
            {
                coordinates: [long, lat]
            },
            balloon
        );

        map.addChild(currentBalloon);
    };

    function closeBalloon() {
        if (!currentBalloon) {
            return;
        }

        map.removeChild(currentBalloon);

        currentBalloon = null;
    }

    // Fillscreen манипуляции
    $(rootDom).closest(".js-contacts-slider__slide-map-wrap").find(".js-contacts-slider__slide-overlay").click(() => {
        toggleFullscreen();
    });

    // Восстанавливаем центр после выхода из fullscreen
    document.addEventListener('fullscreenchange', (e) => {
        if (document.fullscreenElement !== map.container && e.target === map.container) {
            map.update({
                location: {
                    ...LOCATION
                }
            });

            rootDom.style.width = '';
            rootDom.style.height = '';
            closeBalloon();

            // Нужна задержка для корректного расчета размеров карты
            setTimeout(() => {
                map.container.parentElement.classList.remove('_fullscreen');
                swiper.enable();
            }, 10);
        }
    });

    async function toggleFullscreen() {
        if (!document.fullscreenElement) {
            map.container.parentElement.classList.add('_fullscreen');

            rootDom.style.width = screen.width + 'px';
            rootDom.style.height = screen.height + 'px';

            await map.container.requestFullscreen();

            swiper.disable();
        } else {
            await document.exitFullscreen();
        }
    }

    class FullscreenButton extends YMapComplexEntity {
        _createElement() {
            const fullScreenButtonElement = document.createElement('button');
            fullScreenButtonElement.type = 'button';
            fullScreenButtonElement.onclick = () => {
                toggleFullscreen();
            };
            fullScreenButtonElement.classList.add('button', 'exit-fullscreen');

            return fullScreenButtonElement;
        }

        _onAttach() {
            this._element = this._createElement();
            this._detachDom = ymaps3.useDomContext(this, this._element, this._element);
        }

        _onDetach() {
            this._detachDom();
            this._detachDom = null;
            this._element = null;
        }
    }

    const fullScreenBtn = new YMapControl();

    fullScreenBtn.addChild(new FullscreenButton({}));
    map.addChild(new YMapControls({position: 'top right'}, [fullScreenBtn]));
}

$(".js-map-contacts").each((_, mapDom) => {
    initMap(mapDom);
});
